import type { ComponentProps, ForwardRefExoticComponent, RefAttributes } from 'react'

import { Label } from '@/components/ui/label.tsx'

import { EditableComponent } from '@/components/EditableComponent.tsx'
import { DateTimePicker } from '@/components/ui/datetime.tsx'
import { STORY_TYPES } from '@/constants/STORY_TYPES.ts'
import { useMutateStory } from '@/requests/mutations/useMutateStory.ts'
import { getNow, toReadableDateTime } from '@/utils/date.ts'

type EditableVersionProps = {
  storyId: string
  storyType: StoryType
  value: number | null
}

export const EditableDeadline = ({ storyId, storyType, value }: EditableVersionProps) => {
  const { mutate } = useMutateStory(storyId)

  if (storyType !== STORY_TYPES.RELEASE) return null

  return (
    <>
      <Label htmlFor={`story-deadline-${storyId}`} variant="title">
        Release Date
      </Label>
      <div className="flex items-center gap-1">
        <span aria-label="release deadline" className="text-contents-primary font-EN-KR-body2-regular">
          {value ? toReadableDateTime(value, false) : 'Release Date'}
        </span>
        <DateTimePicker
          id={`story-deadline-${storyId}`}
          timestamp={value ?? getNow()}
          setTimestamp={(timestamp) => mutate({ deadline: timestamp })}
        />
      </div>
    </>
  )
}

export const TypedEditableDeadline = EditableComponent as unknown as ForwardRefExoticComponent<
  EditableProps<number, undefined, ComponentProps<typeof EditableDeadline>> & RefAttributes<EditableCommands>
>
